import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import CancelButton from '../atoms/CancelButton';
import ConfirmBatchGochiChargeButton from '../atoms/ConfirmBatchGochiChargeButton';

const styles = {
  textRed: {
    color: 'red'
  },
  breakLine: {
    whiteSpace: 'pre-line'
  },
  textBlack: {
    color: 'black'
  },
  title: {
    fontSize: 20,
    color: 'black',
    whiteSpace: 'pre-line',
    marginBottom: '15px',
    textAlign: 'center'
  }
};

const enhance = compose();

const Main = enhance(
  ({
    openConfirm,
    updateOpenConfirm,
    cancelAction,
    confirmAction,
    validateData,
    classes
  }) => {
    console.log('validateData', validateData.code);
    let message = '';
    let message2 = '';
    if (validateData.code === 200) {
      message2 = `${validateData.numberShop}件をDBにインポートしましょうか？`;
    } else if (validateData.code === 400) {
      // eslint-disable-next-line prefer-destructuring
      message = validateData.message;
      message2 = `エラーのデータを除き、${
        validateData.numberShop
      }件をDBにインポートしましょうか？`;
    } else {
      message = '';
    }
    return (
      <Dialog
        open={openConfirm}
        onClose={() => {
          updateOpenConfirm(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <div className={classes.title}>一括チャージの確認</div>
          <DialogContentText
            id="alert-dialog-description"
            className={[classes.textRed, classes.breakLine]}
          >
            {message}
            <div className={classes.textBlack}>{message2}</div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <CancelButton onClickAction={cancelAction} color="default" />
          <ConfirmBatchGochiChargeButton
            onClickAction={confirmAction}
            validateCode={validateData.code}
          />
        </DialogActions>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
